import React, { useState, useEffect } from 'react';
import { ExpansionList, ExpansionPanel } from 'react-md/lib/ExpansionPanels';
import { DialogContainer } from 'react-md/lib/Dialogs';
import EndorsementsHistoryPanel from './Panels/EndorsementsHistoryPanel';
import EditEndorsement from './EditEndorsement';
import { selectContact } from 'State/Redux/ContactRedux';
import { useSelector, useDispatch } from 'react-redux';
import {
   EndorsementActions,
   selectEndorsementHistory,
   EndorsementTypes,
} from 'State/Redux/EndorsementRedux';
import { FN_EMPTY_VOID } from 'Util/Helpers/Empty';
import { selectIsLoading } from 'State/Redux/AsyncRedux';
import LicencePanel from '../Licences/Panels/LicencePanel';

const EndorsementsTab = (): JSX.Element => {
   const [showModal, setShowModal] = useState(false);
   const [editEndorsementId, setEditEndorsementId] = useState<number | null>(null);

   const endorsements = useSelector(selectEndorsementHistory) || [];
   const isLoading = useSelector(
      selectIsLoading([EndorsementTypes.GET_ENDORSEMENT_HISTORY_BY_ID_REQUEST])
   );

   const contact = useSelector(selectContact);
   const dispatch = useDispatch();

   const openEditModal = (endorsementId: number): void => {
      setEditEndorsementId(endorsementId);
      setShowModal(true);
   };

   const closeModal = (): void => {
      setShowModal(false);
      setEditEndorsementId(null);
   };

   useEffect((): void => {
      if (contact.registrationNumber) {
         dispatch(
            EndorsementActions.getEndorsementHistoryByIdRequest(
               contact.registrationNumber.toString()
            )
         );
      }
   }, [contact.registrationNumber, dispatch]);

   return (
      <ExpansionList className="md-cell md-cell--12">
         <DialogContainer
            id="edit-endorsement-dialog"
            visible={showModal}
            title="Edit Endorsement"
            width={900}
            portal
            onHide={FN_EMPTY_VOID}
         >
            {showModal && editEndorsementId !== null && (
               <EditEndorsement
                  endorsementId={editEndorsementId}
                  closeDialog={closeModal}
               />
            )}
         </DialogContainer>

         <ExpansionPanel
            label={"Endorsements"}
            footer={null}
            expanded
            expanderIcon={<></>}
            onExpandToggle={FN_EMPTY_VOID}
         >
            <LicencePanel />
         </ExpansionPanel>

         <ExpansionPanel
            label="Endorsements History"
            footer={null}
            expanded
            expanderIcon={<></>}
            onExpandToggle={FN_EMPTY_VOID}
         >
            <EndorsementsHistoryPanel
               endorsements={endorsements}
               isLoading={isLoading}
               editEndorsement={(endorsementId: number): void =>
                  openEditModal(endorsementId)
               }
            />
         </ExpansionPanel>
      </ExpansionList>
   );
};

export default EndorsementsTab;
